import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

const DeleteConfirm = ({ show, onClose, onConfirm }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header
      title="Delete Pond?"
      description="All leads in this pond will be reassigned to the account owner."
      closeButton
    />
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button schema="tertiary" size="medium" onClick={onClose}>
        Cancel
      </Button>
      <Button schema="warning" size="medium" onClick={onConfirm}>
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteConfirm.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteConfirm;
